// What the body's parts draw outside the editor: upload meters, the footnote
// dialog and the image / video viewers. Mounted once, next to the editor (not
// inside the contenteditable).
import type { AnyExtension, Editor } from "@tiptap/core";
import { FileUploadMeters } from "./file-upload-meters";
import { FootnoteModalHost } from "./footnote-view";
import { MediaLayers } from "./media";
import { displayBlockViews } from "./views";

export function BlockLayers({
  editor,
  media = true,
  dialogExtensions = displayBlockViews,
}: {
  editor: Editor | null;
  /** Hosts the image and video viewers (off while another host has them). */
  media?: boolean;
  /** What the footnote dialog's editor has (default: the body's display views). */
  dialogExtensions?: () => AnyExtension[];
}) {
  return (
    <>
      <FileUploadMeters editor={editor} />
      <FootnoteModalHost editor={editor} extensions={dialogExtensions} />
      {media && <MediaLayers />}
    </>
  );
}
